<template>
  <v-dialog
    v-model="computedSnowmakingAirwatergunsVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <v-btn icon @click="methodToggleListView('snowmaking', 'airwaterguns')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="hidden-sm-and-down"
          >Air/Water Guns</v-toolbar-title
        >
        <v-spacer class="hidden-sm-and-down"></v-spacer>

        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-text-field
          style="margin-top: -10px"
          append-icon="search"
          single-line
          hide-details
          v-model="search"
          placeholder="Filter data"
        ></v-text-field>
        <v-spacer class="hidden-sm-and-down"></v-spacer>

        <v-menu
          v-if="
            computedAuthProfile === 'admin' ||
              computedAuthProfile === 'maintenance'
          "
          bottom
          left
        >
          <v-btn slot="activator" icon>
            <v-icon>get_app</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click.stop="methodDownloadCSV()">
              <v-list-tile-title>CSV</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              @click.stop="
                methodDownloadKML(
                  $store.state.mapLayers.snowmaking.layers.airwaterguns.geojson,
                  'gun_number',
                  'snowmaking_airwaterguns.kml'
                )
              "
            >
              <v-list-tile-title>KML</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <div
        style="
          background-color: black;
          padding-left: 30px;
          overflow: auto;
          -webkit-overflow-scrolling: touch;
        "
      >
        <v-data-table
          :headers="headers"
          :items="computedSnowmakingAirwatergunsGeoJsonFeatures"
          :rows-per-page-items="rows_per_page"
          :rows-per-page-text="rows_per_page_text"
          :search="search"
          class="elevation-1"
          :loading="computedSnowmakingAirwatergunsLoading"
        >
          <template slot="items" slot-scope="props">
            <tr
              @click="
                methodToggleSingleLayer(
                  'snowmaking',
                  'airwaterguns',
                  true,
                  props.item.properties.id
                )
              "
            >
              <td>{{ props.item.properties.gun_number }}</td>
              <td>{{ props.item.properties.was_demo }}</td>
              <td>{{ props.item.properties.gun_style }}</td>
              <td>{{ props.item.properties.model }}</td>
              <td>{{ props.item.properties.valve }}</td>
              <td>{{ props.item.properties.cfm }}</td>
              <td>{{ props.item.properties.flow_gpm }}</td>
              <td>{{ props.item.properties.length }}</td>
              <td>{{ props.item.properties.serial }}</td>
              <td>{{ props.item.properties.gun_base }}</td>
              <td>{{ props.item.properties.skid }}</td>
              <td>{{ props.item.properties.jack_style }}</td>
              <td>{{ props.item.properties.status }}</td>
              <td>{{ props.item.properties.gun_location }}</td>
              <td>{{ props.item.properties.acquired }}</td>
              <td>{{ props.item.properties.purchased }}</td>
              <td>{{ props.item.properties.edit_by }}</td>
              <td v-if="props.item.properties.modified">
                {{ props.item.properties.modified.split("T")[0] }}
              </td>
            </tr>
          </template>

          <!-- Alert when no results found -->
          <v-alert slot="no-results" :value="true" color="error" icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto"></div>
    </v-card>
  </v-dialog>
</template>
<script>
import { parse } from "json2csv";
export default {
  data() {
    return {
      rows_per_page: [
        10,
        25,
        50,
        {
          text: "All",
          value: -1
        }
      ],
      rows_per_page_text: "Per page:",
      loading: true,
      search: "",
      headers: [
        {
          text: "Gun #",
          value: "properties.gun_number"
        },
        {
          text: "Was demo",
          value: "properties.was_demo"
        },
        {
          text: "Style",
          value: "properties.gun_style"
        },
        {
          text: "Model",
          value: "properties.model"
        },
        {
          text: "Valve",
          value: "properties.valve"
        },
        {
          text: "CFM",
          value: "properties.cfm"
        },
        {
          text: "Flow GPM",
          value: "properties.flow_gpm"
        },
        {
          text: "Length",
          value: "properties.length"
        },
        {
          text: "Serial",
          value: "properties.serial"
        },
        {
          text: "Gun Base",
          value: "properties.gun_base"
        },
        {
          text: "Skid",
          value: "properties.skid"
        },
        {
          text: "Jack Style",
          value: "properties.jack_style"
        },
        {
          text: "Status",
          value: "properties.status"
        },
        {
          text: "Location",
          value: "properties.gun_location"
        },
        {
          text: "Acquired",
          value: "properties.acquired"
        },
        {
          text: "Purchased",
          value: "properties.purchased"
        },
        {
          text: "Last Edit",
          value: "properties.edit_by"
        },
        {
          text: "Modified",
          value: "properties.modified"
        }
      ]
    };
  },
  computed: {
    computedSnowmakingAirwatergunsGeoJsonFeatures() {
      return this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson
        .features;
    },
    computedSnowmakingAirwatergunsVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.airwaterguns
        .visibility.listView;
    },
    computedSnowmakingAirwatergunsLoading() {
      return this.$store.state.mapLayers.snowmaking.layers.airwaterguns.loading;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodDownloadCSV() {
      const fields = [
        {
          label: "Gun #",
          value: "properties.gun_number"
        },
        {
          label: "Was demo",
          value: "properties.was_demo"
        },
        {
          label: "Gun Style",
          value: "properties.gun_style"
        },
        {
          label: "Model",
          value: "properties.model"
        },
        {
          label: "Valve",
          value: "properties.valve"
        },
        {
          label: "CFM",
          value: "properties.cfm"
        },
        {
          label: "Flow GPM",
          value: "properties.flow_gpm"
        },
        {
          label: "Length",
          value: "properties.length"
        },
        {
          label: "Serial Number",
          value: "properties.serial"
        },
        {
          label: "Gun Base",
          value: "properties.gun_base"
        },
        {
          label: "Skid",
          value: "properties.skid"
        },
        {
          label: "Jack Style",
          value: "properties.jack_style"
        },
        {
          label: "Status",
          value: "properties.status"
        },
        {
          label: "Location",
          value: "properties.gun_location"
        },
        {
          label: "Acquired",
          value: "properties.acquired"
        },
        {
          label: "Purchased",
          value: "properties.purchased"
        },
        {
          label: "Comments",
          value: "properties.notes"
        },
        {
          label: "Modified",
          value: "properties.modified"
        }
      ];
      const opts = { fields };

      try {
        const csv = parse(
          this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson.features.sort(
            (a, b) => {
              if (a.properties.hydrnt_num < b.properties.hydrnt_num) return -1;
              if (a.properties.hydrnt_num > b.properties.hydrnt_num) return 1;
              return 0;
            }
          ),
          opts
        );
        const blob = new Blob([csv], { type: "octet/stream" });
        const a = document.createElement("a");
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "snowmaking_airwaterguns.csv";
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      } catch (err) {
        console.error(err);
      }
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetSnowmakingAirwatergunsGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/airwaterguns",
        dept: "snowmaking",
        layer: "airwaterguns",
        token: this.computedAuthToken
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.snowmaking.layers.airwaterguns.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetSnowmakingAirwatergunsGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
